import { render } from "./PurchasesView.vue?vue&type=template&id=34df3a3f&scoped=true"
import script from "./PurchasesView.vue?vue&type=script&lang=js"
export * from "./PurchasesView.vue?vue&type=script&lang=js"

import "./PurchasesView.vue?vue&type=style&index=0&id=34df3a3f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34df3a3f"]])

export default __exports__